export default __webpack_public_path__ + "static/media/PHÂN HỆ RIS.513b6394.pdf";